var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas"}),_c('p',[_vm._v(" Safety Rank"),_c('br'),_vm._v(" Top "),_c('span',[_vm._v(_vm._s(_vm.ranking))]),_vm._v("% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }